import { useSearchParams } from 'react-router-dom';
import { Helmet } from '../components/Helmet';
import { useEffect } from 'react';

const QuestionnairePage = () => {
  const [searchParams] = useSearchParams();
  const client = searchParams.get('client') || '';

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://tally.so/widgets/embed.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Questionnaire Formation IA — Upnov</title>
        <meta
          name="description"
          content="Remplissez le questionnaire de notre formation IA pour nous aider à personnaliser votre expérience d'apprentissage."
        />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      {/* Hero Section */}
      <section className="bg-primary text-white py-12 md:py-16">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="heading-lg mb-4">Questionnaire Formation IA</h1>
            <p className="text-lg">
              Merci de compléter ce questionnaire pour nous aider à adapter la formation à vos besoins.
            </p>
            {client && (
              <p className="text-xl mt-4 opacity-95 font-semibold">
                Client : <span className="text-2xl text-white">{decodeURIComponent(client)}</span>
              </p>
            )}
          </div>
        </div>
      </section>

      {/* Form Section */}
      <section className="section-padding bg-white">
        <div className="container-custom max-w-4xl">
          <iframe
            data-tally-src="https://tally.so/embed/jaV1Q9?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
            loading="lazy"
            style={{
              width: '100%',
              height: '800px',
              border: 'none',
            }}
            title="Questionnaire Formation IA"
          />
        </div>
      </section>

      {/* Footer Info */}
      <section className="bg-gray-50 py-12">
        <div className="container-custom max-w-3xl text-center">
          <h2 className="text-xl font-semibold mb-4">Questions ?</h2>
          <p className="text-gray-600 mb-4">
            Si vous rencontrez des difficultés pour compléter ce questionnaire, n'hésitez pas
            à nous contacter à <strong>info at upnov.com</strong>
          </p>
          <a
            href="/contact/"
            className="inline-flex items-center justify-center bg-primary text-white px-6 py-3 rounded-lg font-medium hover:bg-primary-dark transition-colors"
          >
            Contactez-nous
          </a>
        </div>
      </section>
    </>
  );
};

export default QuestionnairePage;
